import { MouseEvent, useRef } from "react";

interface DoubleClick {
  doubleClickDelay: number;
  onClick: () => unknown;
  onDoubleClick?: () => unknown;
}

const useDoubleClick = ({
  doubleClickDelay,
  onClick,
  onDoubleClick
}: DoubleClick) => {
  const timerRef = useRef<number | null>(null);

  return (event: MouseEvent<HTMLDivElement>): void => {
    event.preventDefault();
    event.stopPropagation();

    if (!timerRef.current) {
      timerRef.current = setTimeout(() => {
        onClick();
        timerRef.current = null;
      }, doubleClickDelay) as unknown as number;
    } else {
      onDoubleClick?.();
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };
};

export default useDoubleClick;
